// @flow
import ComplexTooltip, { type DishItem } from './complex-tooltip';

export default ComplexTooltip;
export type { DishItem };
